import { isFunction } from "lodash-es";
import React, { FC } from "react";

import { Button, IButtonProps } from "@/components/Button";
import { IOpenableButtonProps, OpenableWrapper } from "@/eworkitComponents";
import { IOpenableWrappedProps } from "@/eworkitComponents";

export interface IModalButtonProps
  extends Omit<IOpenableButtonProps, "size" | "color" | "onClick" | "onMouseDown" | "ref" | "variant">,
    Omit<IButtonProps, "ref"> {}

export interface IOpenableModalButtonProps extends IOpenableWrappedProps, IModalButtonProps {}

export const ModalButtonComponent: FC<IOpenableModalButtonProps> = ({
  hideOpenable,
  open,
  showOpenable,
  onClick,
  openable: Openable,
  openableProps,
  ...buttonProps
}) => {
  return (
    <>
      <Button
        {...buttonProps}
        onClick={e => {
          if (isFunction(onClick)) {
            onClick(e);
          }

          showOpenable();
        }}
      />
      <Openable open={open} onClose={hideOpenable} {...openableProps} />
    </>
  );
};

export const ModalButton: FC<IModalButtonProps> = modalProps => (
  <OpenableWrapper>
    {(childProps: IOpenableWrappedProps) => <ModalButtonComponent {...modalProps} {...childProps} />}
  </OpenableWrapper>
);
